import axios from 'axios';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/acesso/cliente/';

class ClienteService {
    constructor() {
        
    }

    findById(idCliente) {
        return axios.get(API_URL + 'findByIdCliente?id=' + idCliente);
    }
}

export default new ClienteService();